/* eslint-disable no-param-reassign */
import { useIsoLayoutEffect } from "./react/useIsoLayoutEffect"

/**
 * A hook that assigns a value to a ref whenever the value changes.
 * Useful for exposing internal values to parent components via refs.
 */
export function useAssignRef<T>({
  ref,
  value
}: {
  ref?: React.MutableRefObject<T | null> | ((value: T) => void)
  value: T
}) {
  useIsoLayoutEffect(() => {
    if (ref && typeof ref === "function") {
      ref(value)
    } else if (ref) {
      ref.current = value
    }
  }, [value, ref])
}
